import React from 'react'
import { Link } from 'react-router-dom';

import Container from '@material-ui/core/Container';

import CurrencySelector from '../../CurrencySelector';
import Typography from '../../Typography';
import SpotlioIcon from '../../Icon';
import MobileTabs from '../HeaderTabs/mobile';
import Currency from '../../Currency';
import Dialog from "../../Dialog";
import Button from "../../Button";

import IntlMessage from '../../../LocaleEngine';

import { getSystemSettings, getAutoModalTimeStamp, setAutoModalTimeStamp } from '../../../utils/SettingsRetriever';
import { getCookie } from '../../../utils/CookiesRetriever';

import { store } from '../../../store/configureStore';

import TATO from './TATO';

import './index.scss';

class Topbar extends React.Component{
    constructor(props){
        super(props);

        const configuration = getSystemSettings();

        // control of no local storage configuration
        // usually when local storage is cleaned during a session
        if(!configuration){
            window.location.reload(false);
        }

        let menuIcon = 'sp3-menu';
        if(! !configuration.assets.mobile.menu_icon) menuIcon = configuration.assets.mobile.menu_icon;
    
        let shoppingCartIcon = 'sp2-shopping-cart';
        if(! !configuration.assets.mobile.cart_icon) shoppingCartIcon = configuration.assets.mobile.cart_icon;
    
        let showLanguage = false;
        if(! !configuration.head.multilanguage) showLanguage = configuration.head.multilanguage;
    
        let showCurrency = false;
        if(! !configuration.head.multicurrency) showCurrency = configuration.head.multicurrency;
    
        let showProfile = false;
        if(! !configuration.head.profile) showProfile = configuration.head.profile;
    
        let phone = false;
        if(! !configuration.head.phone) phone = configuration.head.phone;
        
        let headMode = "default";
        if(! !configuration.head.mode) headMode = configuration.head.mode;

        this.state = {
            menu: false,
            cart: this.getCurrentStateFromStore(),
            b2bCookie: JSON.parse(getCookie('b2b')),
            config: {
                menuIcon: menuIcon,
                shoppingCartIcon: shoppingCartIcon,
                showLanguage: showLanguage,
                showCurrency: showCurrency,
                showProfile: showProfile,
                phone: phone,
                headMode: headMode
            },
            startup_popup: {}
        }
    }

    getCurrentStateFromStore = () => {
        return {
          cart: store.getState().cart.cart.response
        }
    }

    updateStateFromStore = () => {
        const currentStoreState = this.getCurrentStateFromStore();
        const currentState = this.state.cart;

        if (currentState.cart !== currentStoreState.cart) {
          this.setState({...this.state, cart: currentStoreState}, () => {
            this.cartState();
          });
        }
    }

    componentDidMount() {
        this.cartState();
        this.unsubscribeStore = store.subscribe(this.updateStateFromStore);
        if (getSystemSettings().app && getSystemSettings().app.startup_popup && getSystemSettings().app.startup_popup.enabled){
            if ( getAutoModalTimeStamp() && ( getAutoModalTimeStamp() + (getSystemSettings().app.startup_popup.interval * 1000) < new Date().getTime() ) ) {
                this.triggerAutoModal(getSystemSettings().app.startup_popup)
            } else if ( !getAutoModalTimeStamp() ) {
                setTimeout( () =>  { 
                    this.triggerAutoModal(getSystemSettings().app.startup_popup);
                }, getSystemSettings().app.startup_popup.seconds * 1000 )
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribeStore();
    }

    triggerAutoModal = ( startup_popup ) => {
        this.setState({ startup_popup: { ...startup_popup, open: true }}, () => {
            setAutoModalTimeStamp(new Date().getTime()); 
        })
    }

    cartState = () => {
        let state = this.state;
        const storedCart = state.cart.cart;

        let cartBadge = 0;
        let cartTotal = 0;

        if(storedCart){
            if(storedCart.items){
                storedCart.items.forEach(group => {
                    group.items.forEach(item => {
                        let qty = 1;
                        let price = item.Price;
                        if(item.Quantity){
                            qty = item.Quantity;
                        }
                        if(item.UnitaryPrice){
                            price = item.UnitaryPrice;
                        }
                        cartTotal += parseFloat(price) * qty;
                        cartBadge += qty;
                    });
                });
                storedCart.fees.forEach(fee => {
                    cartTotal += parseFloat(fee.Amount) * 1;
                });
            }
        }

        state.cart.badge = cartBadge;
        state.cart.total = cartTotal;

        this.setState(state);
    }

    toggleMenu = (value) => {
        if (window && window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
            window.ReactNativeWebView.postMessage('Menu ' + (value ? 'abierto' : 'cerrado'));
        }

        this.setState({...this.state, menu: value});
    }

    renderTopbarLogo = () => {
        const logo = (<img className={(getSystemSettings().head.logo ? "bigLogo" : "")} alt={getSystemSettings().head.title} src={getSystemSettings().assets.logo || "https://shopspotlio.spotlio.com/bundles/spotliowebappfront/spotlio/images/logo-copper.png"} />);
        if (getSystemSettings().head.site_url === '#' || !getSystemSettings().head.site_url) {
            return (
                <div className="logoWrapper">
                    { logo }
                </div>
            );
        } else {
            return (
                <a className="logoWrapper" rel="noopener noreferrer" target="_blank" href={getSystemSettings().head.site_url} title={getSystemSettings().head.title}>
                    { logo }
                </a>
            )
        }
    }

    renderCartBullet = () => {
        if (this.state.b2bCookie){
            return null;
        }

        return (
        <div onClick={this.props.onTrigger} className="cartBadge">
            <div className="cartIcon">
                <SpotlioIcon icon="sp2-shopping-cart" />
                <div className="cartCounter">
                    <Typography className="h300bold">
                        {this.state.cart.badge}
                    </Typography>
                </div>
            </div>
            <Currency value={this.state.cart.total} noFree={true} />
        </div>
        )
    }

    renderOptions = () => {
        if (this.state.b2bCookie) {
            return (
                <TATO cartLength={this.props.cartLength} onCartTrigger={this.props.onTrigger} b2bCookie={this.state.b2bCookie} />
            )
        }
        
        return (
        <React.Fragment>
            <div className="message">
                {
                    this.state.config.phone ?
                        Array.isArray(this.state.config.phone) ?
                            this.state.config.phone.map((contact, index) => {
                                return (
                                    <div key={index}>
                                        {contact.tel ? <React.Fragment><IntlMessage id={"skin.global.header." + contact.label} />: </React.Fragment>: null } <strong>{contact.tel ? <a href={"tel:" + contact.tel}>{contact.value}</a> : contact.value }</strong>
                                    </div>
                                )
                            })
                            :
                            <div>
                                <IntlMessage id="skin.global.header.contact" /> <strong><a href={"tel:" + this.state.config.phone.tel}>{this.state.config.phone.phone}</a></strong>
                            </div>
                        : ''
                }
            </div>
            <div className="links">
                <ul>
                    {
                        this.state.config.showCurrency && this.state.config.showCurrency.enabled !== false
                        ? <li>
                            <CurrencySelector mode="b2c" />
                        </li> 
                        : ''
                    }
                    {   this.state.config.showLanguage && this.state.config.showLanguage.enabled !== false
                        ? <li>
                            <a href="/#" title="Language">
                                <IntlMessage id={this.state.config.showLanguage.label || "header.info.language"} />
                            </a>
                        </li> 
                        : ''
                    }
                    
                    {   this.state.config.showProfile && this.state.config.showProfile.enabled !== false
                        ? <li>
                            <Link to={getSystemSettings().urlPrefix + '/account'}>
                                <IntlMessage id={this.state.config.showProfile.label || "header.info.my_account"} />
                            </Link>
                        </li> 
                        : ''
                    }
                </ul>
            </div>
        </React.Fragment>
        )
    }

    renderBoxedHeader = () => {
        return (
            <header className="boxedTopbarWrapper">
                <Container className="container" maxWidth="lg">
                    <div className="content">
                        <div className="logo">
                            { this.renderTopbarLogo() }
                        </div>
                        <ul className="menuItems">
                            {
                                getSystemSettings().head.links.map((element, index) => {
                                    return (
                                        <li key={index} className="menuItem">
                                            <a href={element.href}>
                                                {element.name}
                                            </a>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        { this.renderCartBullet() }
                    </div>
                </Container>
                <div className="options">
                    { this.renderOptions() }
                </div>
            </header>
        );
    }

    render(){
        return (
        <React.Fragment>
            { this.state.config.headMode === "boxed" && this.renderBoxedHeader() }
            <header className={"topbarWrapper " + this.state.config.headMode}>
                <MobileTabs toggleMenu={this.toggleMenu.bind(this)} menu={this.state.menu}/>
                <Container className="container" maxWidth="lg">
                    <div onClick={()=>this.toggleMenu(true)} className="menu">
                        <SpotlioIcon icon={this.state.config.menuIcon} />
                    </div>
                    <div className="logo">
                        { this.renderTopbarLogo() }
                    </div>
                    
                    <div className="cart">
                        <span className="fa-stack has-badge" data-count={this.state.cart.badge}>
                            <Link to={getSystemSettings().urlPrefix + '/shopping-cart/review'} className="shoppingcart">
                                <div className="cartIcon">
                                    <SpotlioIcon icon="sp2-shopping-cart" />
                                    <div className="cartCounter">
                                        <Typography className="h200">
                                            {this.state.cart.badge}
                                        </Typography>
                                    </div>
                                </div>
                            </Link>
                        </span>
                    </div>
                    <div className="options">
                        { this.renderOptions() }
                        {
                            getSystemSettings().head && getSystemSettings().head.links &&
                            <div className="menuItems">
                                {
                                    getSystemSettings().head.links.map((element, index) => {
                                        return (
                                            <div key={index} className="menuItem">
                                                <a href={element.href}>
                                                    {element.name}
                                                </a>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                    { this.renderCartBullet() }
                </Container>
            </header>
            <Dialog
                open={this.state.startup_popup.open}
                className="startup_popup"
                footerContent={ <Button onClick={() => this.setState({ startup_popup: { ...this.state.startup_popup, open: false } })}><IntlMessage id="Got it" /></Button> }
            >
                <div className="body" dangerouslySetInnerHTML={{ __html: this.state.startup_popup.message }} />
            </Dialog>
        </React.Fragment>
        )
    }
}

export default Topbar;